import { useFormat } from '@ideavivat/vivat-2';

import usePurchaseOrder from '@/use/usePurchaseOrder';
import { materialCode } from './base';

const { statusClassMap, statusTranslate } = usePurchaseOrder();

export default {
  types: {
    _selectorControls: {
      width: '3rem',
      class: 'text-center',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    status: {
      name: 'สถานะ',
      width: '6rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => statusTranslate(val, -1, -1, row.item.approved, row.item.manager_approved, row.item.chief_manager_approved, row.item.total_price),
      class: {
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return statusClassMap(val, -1, -1, row.item.approved, row.item.manager_approved, row.item.chief_manager_approved, row.item.total_price);
        },
      },
    },
    materialCode: {
      ...materialCode,
      width: '12rem',
    },
    material: {
      name: 'วัสดุ',
      width: '1fr',
      filter: (val: any, row: { item: any }) => `${row.item.material?.name || ''}`,
    },
    amount: {
      name: 'จำนวนที่สั่ง / รับแล้ว',
      width: '8rem',
      filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    // filled_amount: {
    //   name: 'จำนวนที่ได้รับแล้ว',
    //   width: '8rem',
    //   filter: (val: string) => parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    // },
    purchase_unit: {
      name: 'หน่วย',
      width: '6rem',
      // eslint-disable-next-line
      filter: (val: any, row: { item: any }) => `${val ? val : row.item.material?.unit || ''}`,
    },
    target_date: {
      name: 'กำหนดส่ง',
      width: '10rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
    created_at: {
      name: 'วันทำรายการ',
      width: '12rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
    },

  },

};
